module.exports = __webpack_public_path__ + "img/ic_instagram.e00d1d34.svg";